import React, { useState, useEffect } from 'react';

// material-ui
import { CssBaseline, Button, Divider, Grid, Stack} from '@mui/material';

//components
import AlertInfo from '../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../components/elements/AlertInfoDialog';
import TopBar from '../../components/nav/TopBar';

import SqlServerStatus from '../itDashboard/components/SqlServerStatus'

const ItDashboardApp = (): JSX.Element => {

    //set up browser title
    const pageTitle = 'Extranet - IT Dashboard';
    document.title = pageTitle;

    const applicationName = 'IT Dashboard';

    //state initial setup
    const [showDashboard, setShowDashboard] = useState(true);
    const [showSqlServerStatus, setShowSqlServerStatus] = useState(false);

    //payload
    useEffect(() => {
    }, []);


    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }


    const openSqlServerStatus = () => {
        setShowDashboard(false);
        setShowSqlServerStatus(true);
    }

    return (
        <div>
            <Grid container sx={{ display: 'flex' }}>
                <CssBaseline />
                <TopBar applicationName={applicationName} homepageLink={'/Apps/ItDashboard'} ></TopBar>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
                <Divider />
            </Grid>
            {
                showDashboard &&
                <Grid container sx={{ display: 'flex', justifyContent: 'center', marginTop: '30px', marginBottom: '15px' }} >
                    <Grid item xs={10}>
                        <Stack direction="row" spacing={2} >
                                <Button variant="outlined" onClick={openSqlServerStatus} >
                                Sql Server Status
                            </Button>
                        </Stack>
                    </Grid>
                </Grid>
            }
            {
                showSqlServerStatus &&
                <SqlServerStatus></SqlServerStatus>
            }
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    );
};

export default ItDashboardApp;